export enum SettingsCategory {
  INVOICES = 'Invoices',
  DEBIT_NOTES = 'DebitNotes',
  INTEGRATIONS = 'Integrations',
  CREDIT_NOTES = 'CreditNotes',
  PAYOUTS = 'Payouts',
  COMMON = 'Common',
  CONTRACT_DOCUMENTS = 'ContractDocuments',
}

export enum SettingsName {
  // Invoices
  INVOICE_STARTING_NUMBER = 'invoiceStartingNumber',
  INVOICE_CURRENT_NUMBER = 'invoiceCurrentNumber',
  INVOICE_NUMBER_PREFIX = 'invoiceNumberPrefix',
  INVOICE_NUMBER_ENTITY_PREFIX = 'invoiceNumberEntityPrefix',

  // Debit Notes
  DEBIT_NOTE_NUMBER_PREFIX = 'debitNoteNumberPrefix',

  // Integrations
  SALESFORCE_DOMAIN = 'salesforceDomain',

  // Credit Notes
  CREDIT_NOTE_STARTING_NUMBER = 'creditNoteStartingNumber',
  CREDIT_NOTE_CURRENT_NUMBER = 'creditNoteCurrentNumber',
  CREDIT_NOTE_NUMBER_PREFIX = 'creditNoteNumberPrefix',
  CREDIT_NOTE_NUMBER_ENTITY_PREFIX = 'creditNoteNumberEntityPrefix',

  // Payouts
  PAYOUT_NUMBER_PREFIX = 'payoutNumberPrefix',

  // Common
  DEFAULT_CURRENCY = 'defaultCurrency',

  // Contract Documents
  DRAFT_DOCUMENT_STARTING_NUMBER = 'draftDocumentStartingNumber',
}
